import React from 'react'

import * as S from './styles'
import * as T from '../../Typography'
import { Check } from '@mui/icons-material'
import colors from '../../../theme/colors'
import { Controller } from 'react-hook-form'

export type ComponentProps = {
  label?: string;
  placeholder: string;
  error?: string | boolean;
  disabled?: boolean;
  type?: string;
  height?: string;
  value?: boolean;
  onChange?: any;
  optional?: boolean;
  control?: any;
  name?: string;
};

export const Checkbox = 
  (props: ComponentProps) => {
    const { label, value, disabled, onChange, style, ...rest } = props;

    return (
      <S.Wrapper checked={value} disabled={disabled} style={style}>
        <S.Label className="container">
          <T.TextSmallRegular
            color={disabled ? colors.neutral.shades.shade300 : colors.neutral.shades.shade700}
          >
            {label}
          </T.TextSmallRegular>
          <input
            type="checkbox"
            tabIndex={0}
            onChange={onChange}
            {...rest}
          />
          <S.CheckMark className="checkmark" checked={value} disabled={disabled}>
            {value && <Check sx={{ fontSize: 16 }} htmlColor='white'/>}
          </S.CheckMark>
        </S.Label>
      </S.Wrapper>
    )
  }

export const ControllerCheckbox: React.FC<ComponentProps> = ({
  control,
  name = '',
  label,
  placeholder,
  type = 'checkbox',
  disabled = false,
  ...props
}) => {

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={false}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Checkbox
          name={name}
          placeholder={placeholder}
          label={label}
          value={value}
          onChange={(e) => onChange(e.target.checked)}
          error={error?.message || ''}
          disabled={disabled}
          {...props}
        />
      )}
    />
  );
}